import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CONFIG } from './../../../_config/config';
import { MessageService } from 'src/app/_theme/components/message/message.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  public currentCounterOption: any;
  private gateway = this.config.gateway;
  private url= `${this.gateway.urlQuery}/lbw/menus`;

  constructor(
    private http: HttpClient,
    private _notification: MessageService,
    private toastr: ToastrService,
    private config: CONFIG
  ) { }

  onGetMenu() {
    //console.log("notification Menu");
    //console.log(this._notification);
    //this._notification.create("warning", "Existen argumentos requeridos no ingresados.", { Position: "bottom-right", Style: "simple", Duration: 5000 });
    // return this.http.get(`${this.gateway.url}/master/menu`);
    return this.http.get(`${this.url}/menu/option/${sessionStorage.getItem('username')}`);
  }

  setCountMenu(menuitemid) {
    // console.log('Establecer contador')
    if(!menuitemid) {menuitemid = 0}
    const bodyparams: any = {
      "lvMenuItems":menuitemid
    }
    return this.http.post(`${this.url}/menu/lvmenuitems/updatecount`, bodyparams);
  }
}
